<template>
  <div class="page page--ksj">
    <clp-dialog :show=this.showDialog>
      <clp-confirmation
          :step='this.step'
          :loaderType='this.loaderType'
          :msgAlert='this.msgAlert'
          :confirmAvbl='this.codeCheckAvbl'
          @closeDialog="this.showDialog = false"
          @numbersInserted="numbersInserted"
          @checkNumbers="checkNumbers"
          @sendAgain="fetchCode"
      >
      </clp-confirmation>
    </clp-dialog>

    <clp-dialog :show=this.showErrorDialog>
      <clp-error
          :descr="this.errors[1]"
          @closeDialog="this.showErrorDialog = false"
      ></clp-error>
    </clp-dialog>

    <div class="container container--ksj">
      <div class="content content--ksj">
        <h1 class="content__title">Кредитное страхование жизни заемщиков</h1>
        <!-- Преимущества -->
        <section class="content__section content__section--advantages section">

          <h2 class="section__title">Преимущества</h2>

          <div class="cards">
            <ul class="cards__list">
              <li class="cards__item">
                <div class="card card--first">
                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/coins.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Выгода
                      </h3>

                      <p class="card__descr">
                        программа соответствует требованиям Банка УБРиР к&nbsp;страхованию заемщиков (необходимо для
                        снижения ставки по&nbsp;кредиту)
                      </p>
                    </div>

                  </div>
                </div>
              </li>
              <li class="cards__item">
                <div class="card card--middle">
                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/thumbs-up.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Удобство
                      </h3>

                      <p class="card__descr">
                        оформление онлайн, минимум документов
                      </p>
                    </div>
                  </div>

                </div>
              </li>
              <li class="cards__item">
                <div class="card card--middle">
                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/shield.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Безопасность
                      </h3>

                      <p class="card__descr">
                        страховые выплаты, погашающие задолженность
                      </p>
                    </div>

                  </div>

                </div>
              </li>
              <li class="cards__item">
                <div class="card card--middle">

                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/ok-circled.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Стабильность
                      </h3>

                      <p class="card__descr">
                        сохраняйте положительную кредитную историю
                      </p>
                    </div>

                  </div>

                </div>
              </li>
              <li class="cards__item">
                <div class="card card--middle">

                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/handshake.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Ответственность
                      </h3>

                      <p class="card__descr">
                        вашим близким не&nbsp;придется погашать кредит за&nbsp;вас
                      </p>
                    </div>

                  </div>

                </div>
              </li>
              <li class="cards__item">
                <div class="card card--last">

                  <div class="card__content">

                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/icons/court.svg">
                    </div>

                    <div class="card__text">
                      <h3 class="card__title">
                        Надежность
                      </h3>

                      <p class="card__descr">
                        рейтинг СК&nbsp;&laquo;МАКС-Жизнь&raquo; &mdash;
                        <nobr>АА-|ru|</nobr>
                        (высокий уровень кредитоспособности) (ООО&nbsp&laquo;Национальное Рейтинговое Агентство&raquo;
                        (НРА))
                      </p>
                    </div>

                  </div>

                </div>
              </li>

            </ul>
          </div>

        </section>
        <!-- Застрахованные риски -->
        <section class="content__section content__section--risks section section--ksj">
          <h2 class="section__title">Застрахованные риски</h2>

          <div class="minicards__box">
            <ul class="minicards__list">
              <li class="minicards__item">
                <div class="minicard">
                  <p class="minicard__text">
                    Инвалидность I, II группы в результате несчастного случая
                    <nobr>и/или</nobr>
                    заболевания
                  </p>
                </div>
              </li>
              <li class="minicards__item">
                <div class="minicard">
                  <p class="minicard__text">
                    Смерть в результате несчастного случая
                    <nobr>и/или</nobr>
                    заболевания
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <!-- Для оформления страхования заполните поля ниже -->
        <section class="content__section content__section--insurance section section--ksj">
          <h2 class="section__title">Для оформления страхования заполните поля ниже</h2>

          <div class="inputs inputs--insurance">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full">
                <div class="select">
                  <label class="select__label select__label--required" for="credit_term">
                    Срок кредита
                  </label>
                  <select v-model="this.data.agreement.variant_id" class="select__control" name="credit_term"
                          id="credit_term">
                    <option value="notSelected" style="display:none">Срок кредита</option>
                    <option v-for="i of this.creditTermOptions" :value=i.value>{{ i.name }}</option>
                  </select>
                  <label v-if="this.errors[0] === 'credit_term'" class="select__error" for="credit_term">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>


              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full">
                <div class="select">
                  <label class="select__label" for="ins_period">
                    Срок страхования
                  </label>
                  <select disabled v-model="this.data.agreement.ins_period" class="select__control" name="ins_period"
                          id="ins_period">
                    <!-- <option value="notSelected" style="display:none">Срок страхования</option> -->
                    <option value="6M">6 месяцев</option>
                    <option value="12M">1 год</option>
                  </select>
                  <label v-if="this.errors[0] === 'ins_period'" class="select__error" for="ins_period">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>

              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="ins_calc_amount">
                    Сумма кредита
                  </label>
                  <input v-model="this.data.agreement.ins_calc_amount" class="clp-input__control" type="number"
                         id="ins_calc_amount" placeholder="Сумма кредита">
                  <label v-if="this.errors[0] === 'ins_calc_amount'" class="clp-input__error" for="ins_calc_amount">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>


            </ul>
          </div>
        </section>
        <!-- Страхователь -->
        <section class="content__section content__section--insurer section section--ksj">
          <h2 class="section__title">Страхователь</h2>
          <!-- <h2 @click="this.data = JSON.parse(JSON.stringify(this.dataDraft));" class="section__title">Страхователь</h2> -->

          <div class="inputs inputs--fio-sex-birthdate">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="last_name">
                    Фамилия
                  </label>
                  <input v-model="this.data.contacts[0].last_name" class="clp-input__control" type="text" id="last_name"
                         placeholder="Фамилия">
                  <label v-if="this.errors[0] === 'last_name'" class="clp-input__error" for="last_name">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="first_name">
                    Имя
                  </label>
                  <input v-model="this.data.contacts[0].first_name" class="clp-input__control" type="text"
                         id="first_name" placeholder="Имя">
                  <label v-if="this.errors[0] === 'first_name'" class="clp-input__error" for="first_name">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="middle_name">
                    Отчество
                  </label>
                  <input v-model="this.data.contacts[0].middle_name" class="clp-input__control" type="text"
                         id="middle_name" placeholder="Отчество">
                  <label v-if="this.errors[0] === 'middle_name'" class="clp-input__error" for="middle_name">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="select">
                  <label class="select__label select__label--required" for="sex">
                    Пол
                  </label>
                  <select v-model="this.data.contacts[0].sex" class="select__control" name="sex" id="sex">
                    <option value="notSelected" style="display:none">Пол</option>
                    <option value="0">Мужской</option>
                    <option value="1">Женский</option>
                  </select>
                  <label v-if="this.errors[0] === 'sex'" class="select__error" for="sex">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="birth_date">
                    Дата рождения
                  </label>
                  <input v-model="this.data.contacts[0].birth_date" class="clp-input__control" type="date"
                         id="birth_date" placeholder="Дата рождения">
                  <label v-if="this.errors[0] === 'birthDate'" class="clp-input__error" for="birth_date">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div class="inputs inputs--passport">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="serial">
                    Серия паспорта
                  </label>
                  <input v-model="this.data.documents[0].serial"
                         v-mask="{mask: '####',tokens: {'#': { pattern: /\d/ },},}"
                         class="clp-input__control" type="text" id="serial" placeholder="Серия паспорта">
                  <label v-if="this.errors[0] === 'serial'" class="clp-input__error" for="serial">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="number">
                    Hомер паспорта
                  </label>
                  <input v-model="this.data.documents[0].number"
                         v-mask="{mask: '### ###',tokens: {'#': { pattern: /\d/ },},}"
                         class="clp-input__control" type="text" id="number" placeholder="Hомер паспорта">
                  <label v-if="this.errors[0] === 'number'" class="clp-input__error" for="number">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="doc_date">
                    Дата выдачи
                  </label>
                  <input
                      ref="doc_date"
                      v-model="this.data.documents[0].date"
                      class="clp-input__control" type="date" id="doc_date" placeholder="Дата выдачи"
                  >
                  <label v-if="this.errors[0] === 'doc_date'" class="clp-input__error" for="doc_date">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--2-of-3 inputs__item--tablet-full">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="doc_auth">
                    Кем выдан
                  </label>
                  <input v-model="this.data.documents[0].auth" class="clp-input__control" type="text" id="doc_auth"
                         placeholder="Кем выдан">
                  <label v-if="this.errors[0] === 'auth'" class="clp-input__error" for="doc_auth">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="auth_code">
                    Код подразделения
                  </label>
                  <input v-model="this.data.documents[0].auth_code"
                         v-mask="{mask: '###-###',tokens: {'#': { pattern: /\d/ },},}"
                         class="clp-input__control" type="text" maxlength="7" id="auth_code"
                         placeholder="Код подразделения">
                  <label v-if="this.errors[0] === 'auth_code'" class="clp-input__error" for="auth_code">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div class="inputs inputs--phone-email">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="phone_number">
                    Номер телефона
                  </label>
                  <input v-model="this.data.contacts[0].phone"
                         v-mask="{
                                mask: '+7 (FD#) ###-##-##',
                                tokens: {
                                    F: {
                                    pattern: /[3489]/,
                                    },
                                    D: {
                                    pattern: this.data.contacts[0].phone[4] == '8' ? /[0-8]/ : /\d/,
                                    },
                                    '#': { pattern: /\d/ },
                                },
                                }"
                         class="clp-input__control" type="text" id="phone_number" placeholder="Номер телефона">
                  <label v-if="this.errors[0] === 'phone'" class="clp-input__error" for="phone_number">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="email">
                    Электронная почта
                  </label>
                  <input v-model="this.data.contacts[0].email"
                         class="clp-input__control" type="email" id="email" placeholder="Электронная почта">
                  <label v-if="this.errors[0] === 'email'" class="clp-input__error" for="email">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div class="inputs inputs--ins-rate">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-full">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="percentage_with_insurance">
                    Ставка по кредиту со страхованием
                  </label>
                  <input v-model="this.data.agreement.named_params.percentage_with_insurance"
                         v-mask="{mask: '##',tokens: {'#': { pattern: /\d/ }, },}"
                         class="clp-input__control" id="percentage_with_insurance" type="text"
                         placeholder="Ставка по кредиту со страхованием">
                  <label v-if="this.errors[0] === 'percentage_with_insurance'" class="clp-input__error"
                         for="percentage_with_insurance">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--2-of-3 inputs__item--tablet-full">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="percentage_without_insurance">
                    Ставка по кредиту без страхования
                  </label>
                  <input v-model="this.data.agreement.named_params.percentage_without_insurance"
                         v-mask="{mask: '##',tokens: {'#': { pattern: /\d/ }, },}"
                         class="clp-input__control" id="percentage_without_insurance" type="text"
                         placeholder="Ставка по кредиту без страхования">
                  <label v-if="this.errors[0] === 'percentage_without_insurance'" class="clp-input__error"
                         for="percentage_without_insurance">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>

            </ul>
          </div>
        </section>
        <!-- Адрес регистрации -->
        <section class="content__section content__section--address section section--ksj">
          <h2 class="section__title">Адрес регистрации</h2>

          <div class="inputs inputs--address">
            <ul class="inputs__list">
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label" for="index">
                    Индекс
                  </label>
                  <input v-model="this.data.addresses[0].index"
                         v-mask="{mask: '######',tokens: {'#': { pattern: /\d/ },},}"
                         class="clp-input__control" type="text" id="index" placeholder="Индекс">
                  <label v-if="this.errors[0] === 'index'" class="clp-input__error" for="index">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--2-of-3 inputs__item--tablet-full">
                <clp-autocomplete
                    :options="this.citiesOptions"
                    :newText="this.insertedCity"
                    @searchOptions="searchCityOptions"
                    @optionSelected="cityOptionSelected"
                    label-text='Город' :show-err="this.errors[0] === 'city'" :err-text="this.errors[1]"
                />
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <clp-autocomplete
                    :options="this.streetsOptions"
                    :newText="this.insertedStreet"
                    @searchOptions="searchStreetOptions"
                    @optionSelected="streetOptionSelected"
                    label-text='Улица' :show-err="this.errors[0] === 'street'" :err-text="this.errors[1]"
                />
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label clp-input__label--required" for="house">
                    Дом
                  </label>
                  <input v-model="this.data.addresses[0].house" class="clp-input__control" type="tel" maxlength="4"
                         id="house" placeholder="Дом">
                  <label v-if="this.errors[0] === 'house'" class="clp-input__error" for="house">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-hidden">
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label" for="housing">
                    Корпус
                  </label>
                  <input v-model="this.data.addresses[0].housing" class="clp-input__control" type="text" id="housing"
                         placeholder="Корпус">
                  <label v-if="this.errors[0] === 'housing'" class="clp-input__error" for="housing">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label" for="building">
                    Строение
                  </label>
                  <input v-model="this.data.addresses[0].building" class="clp-input__control" type="text" id="building"
                         placeholder="Строение">
                  <label v-if="this.errors[0] === 'building'" class="clp-input__error" for="building">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
              <li class="inputs__item inputs__item--1-of-3 inputs__item--tablet-1-of-2">
                <div class="clp-input">
                  <label class="clp-input__label" for="apartment">
                    Квартира
                  </label>
                  <input v-model="this.data.addresses[0].apartment" class="clp-input__control" type="tel" maxlength="4"
                         id="apartment" placeholder="Квартира">
                  <label v-if="this.errors[0] === 'apartment'" class="clp-input__error" for="apartment">
                    {{ this.errors[1] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <!-- Я принимаю условия обработки моих персональных данных -->
        <section class="content__section content__section--confirmation section section--ksj">
          <div class="section__left">
            <div class="checkboxes">
              <ul class="checkboxes__list">
                <li class="checkboxes__item">
                  <div class="checkbox">
                    <input v-model="markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                           value="personal_data" id="checkbox1">

                    <label class="checkbox__label" for="checkbox1">

                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>

                      <span class="checkbox__label--text">
                                            Я принимаю 
                                            <a class="clp-link" target="_blank"
                                               href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">условия обработки моих персональных данных</a>
                                            </span>

                    </label>
                  </div>
                </li>


                <li v-show="newKidArrived" class="checkboxes__item">
                  <div class="checkbox">
                    <input v-model="markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                           value="kid_and_ins_terms" id="checkbox2">

                    <label class="checkbox__label" for="checkbox2">

                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>

                      <span class="checkbox__label--text">
                                            Я ознакомлен с  
                                            <a class="clp-link" target="_blank" :href="kidLink">Ключевым информационным документом (КИД)</a>
                                        </span>

                    </label>
                  </div>
                </li>
                <li v-show="!newKidArrived" class="checkboxes__item">
                  <div class="checkbox">
                    <input disabled class="checkbox__input" type="checkbox" name="check[]" value="disabled"
                           id="disabled">

                    <label class="checkbox__label" for="disabled">

                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>

                      <span class="checkbox__label--text">
                                            Я ознакомлен с  
                                            <a class="clp-link clp-link--disabled">Ключевым информационным документом (КИД)</a>
                                        </span>

                    </label>
                  </div>
                </li>


                <li v-show="newKidArrived" class="checkboxes__item">
                  <div class="checkbox">
                    <input v-model="markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                           value="policy_terms_and_ins_rules" id="checkbox3">

                    <label class="checkbox__label" for="checkbox3">

                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>

                      <span class="checkbox__label--text">
                                            Я ознакомился с 
                                            <a class="clp-link" target="_blank" :href="policyLink">Условиями полиса</a> и 
                                            <a class="clp-link" target="_blank"
                                               href="https://makclife.ru/upload/medialibrary/791/rule_09_8.pdf">Правилами страхования</a>
                                            </span>

                    </label>
                  </div>
                </li>
                <li v-show="!newKidArrived" class="checkboxes__item">
                  <div class="checkbox">
                    <input disabled class="checkbox__input" type="checkbox" name="check[]" value="disabled2"
                           id="disabled2">

                    <label class="checkbox__label" for="disabled2">

                                            <span class="checkbox__label--icon">
                                                <img class="icon" src="@/create/assets/icons/check.svg">
                                            </span>

                      <span class="checkbox__label--text">
                                            Я ознакомился с 
                                            <a class="clp-link clp-link--disabled">Условиями полиса</a> и 
                                            <a class="clp-link clp-link--disabled">Правилами страхования</a>
                                        </span>

                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="section__subtitle">
              После оплаты полис и&nbsp;комплект страховых документов будут направлены на&nbsp;указанный Вами адрес
              электронной почты.
            </div>
          </div>
          <div class="section__right">
            <button v-show="orderButtonActive" @click="btnConfirm()" class="section__button button"
            >Оформить
            </button>
            <button v-show="!orderButtonActive" disabled class="section__button button"
            >Оформить
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>


<script>
import ClpDialog from '@/create/components/ClpDialog.vue'
import ClpConfirmation from '@/create/components/ClpConfirmation.vue'
import ClpError from '@/create/components/ClpError.vue'
import ClpAutocomplete from '@/create/components/ClpAutocomplete.vue'
import axios from "axios";
import {localDevelopment, testDevelopment, baseURL, requestVersion} from "@/create/composables/const";

export default {
  components: {
    ClpDialog, ClpConfirmation, ClpError, ClpAutocomplete
  },
  data() {
    return {
      cyrillic: /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/,
      latin: /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/,
      showDialog: false,
      showErrorDialog: false,
      orderButtonActive: false,
      newKidArrived: false,
      requestAvailable: false,
      requestArrived: true,
      codeCheckAvbl: false,
      markedCheckboxes: [],
      errors: [],
      creditTermOptions: [],
      citiesOptions: [],
      streetsOptions: [],
      copyData: {},
      kidLink: '#',
      policyLink: '#',
      insertedCity: '',
      insertedStreet: '',
      sessionToken: '',
      step: 'loader',
      loaderType: 'contract',
      contractId: '',
      msgAlert: '',
      numbers: '',
      data: {
        format: "json",
        object: "contract",
        action: "check",
        login: "ybrir",
        agreement: {
          program: "cred_ubr",
          ins_calc_amount: '',
          ins_calc_type: 1,
          ins_period: "notSelected",
          payment_order: 0,
          currency: "rur",
          insurer: 0,
          insured: 0,
          status: 10,
          bank_policy_premium: 0,
          ins_rules: true,
          variant_id: "notSelected",
          variant_type: 8,
          named_params: {
            percentage_with_insurance: '',
            percentage_without_insurance: ''
          },
          creat_previe_police: 'Y'
        },
        documents: [{
          type: 1,
          serial: "",
          number: "",
          date: "",
          auth: "",
          auth_code: ""
        }
        ],
        addresses: [{
          index: "",
          city: "",
          city_code: "",
          street: "",
          street_code: "",
          house: "",
          housing: "",
          building: "",
          apartment: ""
        }],
        contacts: [{
          first_name: "",
          middle_name: "",
          last_name: "",
          birth_date: "",
          phone: "",
          email: "",
          birth_place: "Место рождение",
          citizenship: "ru",
          sex: "notSelected",
          documents: [0],
          addresses: [0]
        }
        ]
      },
      dataDraft: {
        format: "json",
        object: "contract",
        action: "check",
        agreement: {
          program: "cred_ubr",
          ins_calc_amount: '',
          ins_calc_type: 1,
          ins_period: "notSelected",
          payment_order: 0,
          currency: "rur",
          insurer: 0,
          insured: 0,
          status: 10,
          bank_policy_premium: 0,
          ins_rules: true,
          variant_id: "notSelected",
          variant_type: 8,
          named_params: {
            percentage_with_insurance: '',
            percentage_without_insurance: ''
          },
          creat_previe_police: 'Y'
        },
        documents: [{
          type: 1,
          serial: "",
          number: "",
          date: "",
          auth: "",
          auth_code: ""
        }
        ],
        addresses: [{
          index: "",
          city: "",
          city_code: "",
          street: "",
          street_code: "",
          house: "",
          housing: "",
          building: "",
          apartment: ""
        }],
        contacts: [{
          first_name: "",
          middle_name: "",
          last_name: "",
          birth_date: "",
          phone: "",
          email: "",
          birth_place: "Место рождение",
          citizenship: "ru",
          sex: "notSelected",
          documents: [0],
          addresses: [0]
        }
        ]
      },

    };
  },
  watch: {
    data: {
      handler(val) {
        this.newKidArrived = false;
        this.orderButtonActive = false;
        this.markedCheckboxes = [];

        if (this.frontValidate()) {
          this.requestAvailable = true
        } else {
          // console.log('frontValidate error - ' + this.errors);
          this.requestAvailable = false
        }

        if (val.agreement.variant_id == 'notSelected') {
          this.data.agreement.ins_period = this.data.agreement.ins_period
        } else if (val.agreement.variant_id == '112') {
          this.data.agreement.ins_period = '6M'
        } else {
          this.data.agreement.ins_period = '12M'
        }
      },
      deep: true
    },
    markedCheckboxes(val) {
      if (val.length === 3) {
        this.orderButtonActive = true;
      } else {
        this.orderButtonActive = false;
      }
    },
    insertedCity(val) {
      this.errors = [];
      if (val.length === 0) {
        this.citiesOptions = [];

        this.data.addresses[0].city = '';
        this.data.addresses[0].city_code = '';
        this.data.addresses[0].street = '';
        this.data.addresses[0].street_code = '';

        this.newKidArrived = false;
        this.orderButtonActive = false;
        this.markedCheckboxes = [];

        this.errors.push('city');
        this.errors.push('укажите город');
      } else if (!this.cyrillic.test(val)) {
        this.errors.push('city');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getCities(val);
      }
    },
    insertedStreet(val) {
      if (!this.data.addresses[0].city_code && val.length > 0) {
        this.errors.push('street');
        this.errors.push('сначала выберите город');
      } else if (val.length === 0) {
        this.streetsOptions = [];

        this.data.addresses[0].street = '';
        this.data.addresses[0].street_code = '';

        this.newKidArrived = false;
        this.orderButtonActive = false;
        this.markedCheckboxes = [];

        this.errors.push('street');
        this.errors.push('укажите улицу');
      } else if (!this.cyrillic.test(val)) {
        this.errors = [];
        this.errors.push('street');
        this.errors.push('допустимы только символы кириллицы');
      } else {
        this.errors = [];
        this.getStreets(val);
      }
    }
  },
  methods: {
    // валидация
    frontValidate() {
      this.errors = [];
      const authCode = /[0-9][0-9][0-9]\-[0-9][0-9][0-9]/;
      const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;

      // Для оформления страхования заполните поля ниже
      if (this.data.agreement.variant_id === 'notSelected') {
        this.errors.push('credit_term');
        this.errors.push('укажите срок кредита');
        return false
      } else if (this.data.agreement.ins_period === 'notSelected') {
        this.errors.push('ins_period');
        this.errors.push('укажите срок страхования');
        return false
      } else if (this.data.agreement.ins_calc_amount < 1) {
        this.errors.push('ins_calc_amount');
        this.errors.push('укажите сумму кредита');
        return false
      } else if (this.data.agreement.ins_calc_amount > 15000000) {
        this.errors.push('ins_calc_amount');
        this.errors.push('сумма кредита превышает максимальное значение');
        return false
      }
      // ФИО-Пол-ДР
      else if (!this.data.contacts[0].last_name) {
        this.errors.push('last_name');
        this.errors.push('укажите фамилию');
        return false
      } else if (!this.cyrillic.test(this.data.contacts[0].last_name)) {
        this.errors.push('last_name');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (!this.data.contacts[0].first_name) {
        this.errors.push('first_name');
        this.errors.push('укажите имя');
        return false
      } else if (!this.cyrillic.test(this.data.contacts[0].first_name)) {
        this.errors.push('first_name');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (!this.data.contacts[0].middle_name) {
        this.errors.push('middle_name');
        this.errors.push('укажите отчество');
        return false
      } else if (!this.cyrillic.test(this.data.contacts[0].middle_name)) {
        this.errors.push('middle_name');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (this.data.contacts[0].sex === 'notSelected') {
        this.errors.push('sex');
        this.errors.push('укажите пол');
        return false
      } else if (!this.data.contacts[0].birth_date) {
        this.errors.push('birthDate');
        this.errors.push('укажите дату рождения страхователя');
        return false
      } else if (this.getAge(this.data.contacts[0].birth_date) < 18 || this.getAge(this.data.contacts[0].birth_date) > 75) {
        this.errors.push('birthDate');
        this.errors.push('допустимый возраст страхователя - от 18 до 75 лет');
        return false
      }
      // Документ
      else if (!this.data.documents[0].serial) {
        this.errors.push('serial');
        this.errors.push('укажите серию паспорта');
        return false
      } else if (this.data.documents[0].serial.length !== 4) {
        this.errors.push('serial');
        this.errors.push('укажите серию паспорта (4 цифры)');
        return false
      } else if (!this.data.documents[0].number) {
        this.errors.push('number');
        this.errors.push('укажите номер паспорта');
        return false
      } else if (this.data.documents[0].number.length !== 7) {
        this.errors.push('number');
        this.errors.push('укажите номер паспорта (6 цифр)');
        return false
      } else if (!this.data.documents[0].date) {
        this.errors.push('doc_date');
        this.errors.push('укажите дату выдачи');
        return false
      } else if (!this.checkDocDate()) {
        this.errors.push('doc_date');
        this.errors.push('укажите корректную дату выдачи (с 14 лет)');
        return false
      } else if (!this.data.documents[0].auth) {
        this.errors.push('auth');
        this.errors.push('укажите подразделение');
        return false
      } else if (!this.cyrillic.test(this.data.documents[0].auth)) {
        this.errors.push('auth');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (!this.data.documents[0].auth_code) {
        this.errors.push('auth_code');
        this.errors.push('укажите код подразделения');
        return false
      } else if (!authCode.test(this.data.documents[0].auth_code)) {
        this.errors.push('auth_code');
        this.errors.push('укажите код подразделения в формате 123-456');
        return false
      }
      // Телефон-Емейл-Ставка
      else if (!this.data.contacts[0].phone) {
        this.errors.push('phone');
        this.errors.push('укажите номер телефона');
        return false
      } else if (this.data.contacts[0].phone.length < 18) {
        this.errors.push('phone');
        this.errors.push('укажите номер телефона полностью');
        return false
      } else if (!this.data.contacts[0].email) {
        this.errors.push('email');
        this.errors.push('укажите адрес электронной почты');
        return false
      } else if (!email.test(this.data.contacts[0].email)) {
        this.errors.push('email');
        this.errors.push('укажите корректный адрес электронной почты');
        return false
      } else if (!this.data.agreement.named_params.percentage_with_insurance) {
        this.errors.push('percentage_with_insurance');
        this.errors.push('укажите ставку в процентах');
        return false
      } else if (!this.data.agreement.named_params.percentage_without_insurance) {
        this.errors.push('percentage_without_insurance');
        this.errors.push('укажите ставку в процентах');
        return false
      } else if (parseInt(this.data.agreement.named_params.percentage_with_insurance)
          >= parseInt(this.data.agreement.named_params.percentage_without_insurance)) {
        this.errors.push('percentage_without_insurance');
        this.errors.push('должна превышать ставку по кредиту со страхованием');
        return false
      }

      // Адрес регистрации
      else if (!this.data.addresses[0].city || !this.data.addresses[0].city_code) {
        this.errors.push('city');
        this.errors.push('укажите город');
        return false
      } else if (!this.cyrillic.test(this.data.addresses[0].city)) {
        this.errors.push('city');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (!this.data.addresses[0].street) {
        this.errors.push('street');
        this.errors.push('укажите улицу');
        return false
      } else if (!this.cyrillic.test(this.data.addresses[0].street)) {
        this.errors.push('street');
        this.errors.push('допустимы только символы кириллицы');
        return false
      } else if (!this.data.addresses[0].house) {
        this.errors.push('house');
        this.errors.push('укажите дом');
        return false
      }

      return true
    },
    // запросы
    requestInterval() {
      setInterval(() => {
        if (this.requestAvailable && this.requestArrived) {
          this.requestAvailable = false
          this.requestArrived = false
          this.backValidateAndGetKid()
        }
      }, 5000);
    },
    async getCreditTerm() {
      try {
        console.log('getCreditTerm request');

        const request = {
          sessionToken: this.sessionToken,
          format: "json",
          ver: requestVersion,
          action: "getlistnames",
          login: "ybrir",
          variant_type: "8",
        }

        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === "success") {
          this.creditTermOptions = r_data.listname;
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.showDialog = false;
          this.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after getCreditTerm request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.requestInterval()
      }
    },
    async getCities(val) {
      try {
        console.log('getCities request');
        const request = {
          sessionToken: this.sessionToken,
          action: "kladrlife",
          login: "ybrir",
          kladr: {
            type: "city",
            term: val
          },
        }

        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === "success" && r_data.kladr.length > 0) {
          this.citiesOptions = r_data.kladr;
        } else if (r_data.state !== "success") {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.showDialog = false;
          this.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after getCities request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async getStreets(val) {
      try {
        console.log('getStreets request');

        const request = {
          sessionToken: this.sessionToken,
          action: "kladrlife",
          login: "ybrir",
          kladr: {
            type: "street",
            term: val,
            city_code: this.data.addresses[0].city_code
          },
        }

        // const response = await axios.post(`https://test.makclife.ru/create/app.php`, request);
        const response = await axios.post(baseURL, request);


        // const r_data = JSON.parse(response.data);
        const r_data = response.data;

        if (r_data.state === "success" && r_data.kladr.length > 0) {
          this.streetsOptions = r_data.kladr;
        } else if (r_data.state !== "success") {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.showDialog = false;
          this.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after getStreets request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async backValidateAndGetKid() {
      try {
        this.newKidArrived = false;

        this.copyData = JSON.parse(JSON.stringify(this.data));
        this.transformData(this.copyData);

        console.log('Kid request');

        // const response = await axios.post(`https://test.makclife.ru/create/app.php`, this.copyData);
        const response = await axios.post(baseURL, this.copyData);

        // const r_data = JSON.parse(response.data);
        const r_data = response.data;

        if (r_data.error_code === 4140) {
          const domain = localDevelopment || testDevelopment ? "https://dev4.makclife.ru" : "https://makclife.ru";
          const urlKid = r_data.error.use.named_params_kid_signed.link;
          const urlPolicy = r_data.error.use.named_params_kid_signed.policy.link;

          this.kidLink = domain + urlKid;
          this.policyLink = domain + urlPolicy;
          this.newKidArrived = true;
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.showDialog = false;
          this.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after Kid request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.requestArrived = true
      }
    },
    async fetchContract() {
      try {
        console.log('fetchContract request');
        const response = await axios.post(baseURL, this.copyData);
        const r_data = response.data;

        if (r_data.state === 'success') {
          this.contractId = r_data.id;

          this.fetchCode();
          this.step = 'confirm'
        } else if (r_data.error.use.insurer_doc_date) {
          this.showDialog = false;

          const newErrors = [];
          newErrors.push('doc_date');
          newErrors.push(r_data.error.use.insurer_doc_date[0].error);
          this.confirmationError(newErrors)

          console.log('doc_date error after fetchContract request');
        } else {
          this.showDialog = false;

          this.errors.push('backendError');
          this.errors.push(r_data);

          console.log('backend error after fetchContract request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async fetchCode() {
      try {
        console.log('fetchCode request to ' + this.copyData.contacts[0].phone);

        const request = {
          sessionToken: this.sessionToken,
          format: "json",
          ver: requestVersion,
          action: "generatesigncheckcode",
          code_sign: "contact",
          id_sign: this.contractId,
          phone: this.copyData.contacts[0].phone,
          methods: "SMS"
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'error') {
          this.msgAlert = r_data.msg;

          console.log("r_data.msg - " + r_data.msg);
        } else if (r_data.state === 'success') {
          this.msgAlert = 'Код отправлен на указанный номер'
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async checkNumbers() {
      try {
        this.codeCheckAvbl = false;
        this.msgAlert = '';
        console.log('checkNumbers request by ' + this.numbers);

        const request = {
          sessionToken: this.sessionToken,
          format: "json",
          ver: requestVersion,
          action: "comparesigncheckcode",
          check_sign: this.numbers,
          code_sign: "contact",
          id_sign: this.contractId
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          this.step = 'loader';
          this.loaderType = 'invoice';

          this.fetchInvoice();
        } else if (r_data.state === 'error') {
          this.msgAlert = 'Введен неверный код';

          console.log("r_data.msg - " + r_data.msg);
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async fetchInvoice() {
      try {
        console.log('fetchInvoice request');

        const request = {
          sessionToken: this.sessionToken,
          format: "json",
          ver: requestVersion,
          action: "creatpay",
          login: "ybrir",
          policy_id: this.contractId,
          phone: this.data.contacts[0].phone,
          email: this.data.contacts[0].email
        }

        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          const paylink = r_data.url.link;
          window.open(paylink, '_self')
        } else {
          this.errors.push('backendError');
          this.errors.push(r_data);

          this.showDialog = false;
          this.showErrorDialog = true;

          this.errorLogger(r_data);

          console.log('backend error after fetchInvoice request');
        }

      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
      }
    },
    async errorLogger(error) {
      try {
        console.log('error log sending');

        const currentDate = this.getTodaysDate();

        const request = {
          sessionToken: this.sessionToken,
          action: "logger",
          login: "ybrir",
          date: currentDate,
          data: error
        }
        const response = await axios.post(baseURL, request);

        console.log('error log response' + response.data);
      } catch (e) {
      } finally {
      }
    },
    // работа с данными
    transformData(obj) {
      const reworkDate = (date) => {
        const result = date.split("-").reverse().join(".");
        return result
      }
      const reworkDocNumber = (doc) => {
        const nums = /([0-9])/g;

        let result = doc.match(nums).join('');

        return result
      }
      const reworkPhone = (phone) => {
        const nums = /([0-9]|[+])/g;

        let result = phone.match(nums).join('');

        return result
      }
      obj.contacts[0].birth_date = reworkDate(this.data.contacts[0].birth_date);
      obj.documents[0].date = reworkDate(this.data.documents[0].date);

      obj.documents[0].number = reworkDocNumber(this.data.documents[0].number);

      obj.contacts[0].phone = reworkPhone(this.data.contacts[0].phone);

      obj.sessionToken = this.sessionToken;
    },
    getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    checkDocDate() {
      if ((this.getAge(this.data.contacts[0].birth_date) - this.getAge(this.data.documents[0].date)) < 14) {
        return false
      } else {
        return true
      }
    },
    // слушатели
    searchCityOptions(val) {
      this.insertedCity = val
    },
    searchStreetOptions(val) {
      this.insertedStreet = val
    },
    cityOptionSelected(item) {
      this.data.addresses[0].street = '';
      this.data.addresses[0].street_code = '';

      this.data.addresses[0].city = item.label;
      this.data.addresses[0].city_code = item.id;
      this.insertedStreet = '';
    },
    streetOptionSelected(item) {
      this.data.addresses[0].street = item.label;
      this.data.addresses[0].street_code = item.id;
    },
    // действия и ошибки
    btnConfirm() {
      this.copyData.agreement.kid_signed = 'Y';
      this.copyData.action = 'create';

      this.showDialog = true;
      this.fetchContract();
    },
    numbersInserted(numbers) {
      this.numbers = numbers;
      this.codeCheckAvbl = true;
    },
    confirmationError(arr) {
      this.errors = arr;

      if (arr[0] === 'doc_date') {
        this.$refs.doc_date.focus();

        return
      } else {
        this.errorLogger(arr[1]);
      }

      this.showErrorDialog = true;
    },
  },
  mounted() {
    this.sessionToken = new Date;
    this.getCreditTerm()
  }
}
</script>


<style scoped lang="scss">
</style>
